enum RestErrorCode {
  WrongCredentials = 'WrongCredentials',
  UnexpectedError = 'UnexpectedError',
  DuplicateEmail = 'DuplicateEmail',
  DuplicatePhone = 'DuplicatePhone',
  DuplicateEntry = 'DuplicateEntry',
  AlreadyExists = 'AlreadyExists',
  UserEmailNotFound = 'UserEmailNotFound',
  UserActivationFailed = 'UserActivationFailed',
  UserPasswordResetCodeNotFound = 'UserPasswordResetCodeNotFound',
  UserPasswordResetCodeExpired = 'UserPasswordResetCodeExpired',
  InvalidFileType = 'InvalidFileType',
  ScanMarkedAsUnknown = 'ScanMarkedAsUnknown',
  ApproverMustNotBeReviewer = 'ApproverMustNotBeReviewer',
  InventoryDeleteFailedInventoryLinked = 'InventoryDeleteFailedInventoryLinked',
  InventoryDeleteFailedSameInventory = 'InventoryDeleteFailedSameInventory',
}

export default RestErrorCode;
